module.exports = __webpack_public_path__ + "static/media/photo.b088024d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo.svg
// module id = 1444
// module chunks = 0